.sn-roi-benefits-type-1 {
  display: flex;
  flex-direction: column;

  &__header {
    display: flex;
    flex-direction: column;
    margin-bottom: map-get($spacings, 2xl);

    @include above($breakpoint-desktop-md) {
      margin-bottom: map-get($spacings, 3xl);
    }

    .me-text {
      @include above($breakpoint-desktop-md) {
        max-width: calc(100% * 8 / 12);
      }
    }
  }

  &__card {
    background-color: var(--color-brand-primary-lightest); // TODO: no exact token
    border-radius: var(--radius-size-lg);
    padding: map-get($spacings, xl) map-get($spacings, md);

    @include above($breakpoint-desktop) {
      padding: map-get($spacings, 3xl) map-get($spacings, xl);
    }

    @include above($breakpoint-desktop-md) {
      padding: map-get($spacings, 5xl) map-get($spacings, 3xl);
    }
  }

  &__stats {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, lg);

    @include above($breakpoint-desktop) {
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 0;
    }
  }

  &__stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: map-get($spacings, xs);
    flex: 1;
    padding: map-get($spacings, lg) 0;

    @include above($breakpoint-desktop) {
      padding: 0 map-get($spacings, 3xl);
    }
  }

  &__value {
    font-weight: 700;
    font-size: map-get($font-sizes, 5xl);
    line-height: 1;
    color: var(--color-text-primary);

    @include above($breakpoint-desktop-md) {
      font-size: 90px; // TODO: no exact token
    }
  }

  &__label {
    font-weight: 400;
    font-size: map-get($font-sizes, lg);
    line-height: map-get($line-heights, lg);
    color: var(--color-text-primary);
    text-align: center;
  }

  .me-heading--4 {
    font-size: map-get($font-sizes, 2xl);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, 3xl);
    }

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, 4xl);
    }
  }

  .me-heading--6 {
    font-size: 24px;
    line-height: 32px;
  }

  .me-text {
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }
}
